import { css, type Theme } from '@emotion/react';

import { LESSON_CARD_THUMBNAIL_ASPECT_RATIO } from '@didaskill/domain/lessons/constants';

export const content = css`
  padding: 8px;
  position: relative;
  z-index: 1;
`;

export const container = (theme: Theme) => css`
  width: 264px;
  height: 218px;

  position: relative;
  overflow: hidden;
  z-index: 1;

  transition: background-color 0.4s ease-in-out;

  border-radius: 8px;

  &.isLocked {
    // White stripes on background
    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 200%;
      background-color: ${theme.colors.gray[0]};
      opacity: 0.7;
      transform: rotate(-60deg) translateY(0);
      left: -50%;
      z-index: 0;
      pointer-events: none;
      transition: transform 0.6s ease-in-out;
    }

    &::before {
      height: 50px;
      top: 100px;
    }

    &::after {
      height: 30px;
      top: 210px;
    }

    &:hover {
      background-color: ${theme.colors.gray[0]};

      &::before,
      &::after {
        transform: rotate(-60deg) translateY(-150%);
      }
    }

    // Display button and hide tag on hover
    .hide-on-hover {
      transition: opacity 0.6s ease;
    }

    .display-on-hover {
      opacity: 0;
      transition: opacity 0.6s ease;
    }

    &:hover {
      .hide-on-hover {
        opacity: 0;
      }

      .display-on-hover {
        opacity: 1;
      }

      .opacity-on-hover {
        opacity: 1;
      }
    }
  }
`;

export const thumbnail = (theme: Theme) => css`
  width: 100%;
  aspect-ratio: ${LESSON_CARD_THUMBNAIL_ASPECT_RATIO};
  z-index: 1;
  overflow: hidden;

  &.isDisabled {
    opacity: 0.2;
  }

  &.isLocked {
    opacity: 0.7;
  }

  &.isExternal {
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      background: linear-gradient(
        180deg,
        ${theme.colors.gray[900]} 0%,
        transparent 100%
      );
    }
  }
`;

export const image = (imageSrc: string) => {
  return css`
    background-image: url(${imageSrc});
    background-size: cover;
    background-position: center;

    border-radius: 4px;

    height: 119px;
  `;
};

export const placeholderImage = (theme: Theme) => css`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  background-color: ${theme.colors.primary[15]};
`;

export const title = (theme: Theme) => css`
  &.isDisabled {
    color: ${theme.colors.gray[300]};
  }
`;

export const footer = css`
  padding: 8px;
  position: absolute;
  bottom: 0;
  z-index: 1;
  width: 100%;
`;

export const info = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
`;

export const logoContainer = css`
  position: absolute;
  top: 8px;
  left: 8px;

  z-index: 2;
`;

export const completedText = (theme: Theme) => css`
  color: ${theme.colors.success[700]};
`;

export const lockedButton = css`
  position: absolute;
  bottom: 8px;

  width: 248px;

  display: flex;
  justify-content: center;
`;
